import React, { useCallback } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import { Typography, View } from '@memoryfactory/mui-components';
import { Button } from '@material-ui/core';

function IEDialog() {
  const onClickLink = useCallback(() => {
    window.location.href = 'https://www.google.com/intl/ko/chrome/';
  }, []);

  return (
    <Dialog open maxWidth="md">
      <DialogContent>
        <View mb={6}>
          <Typography variant="h5" gutterBottom align="center">
            알림
          </Typography>
          <Typography gutterBottom align="center">
            본 서비스는 크롬 브라우저에 최적화 되어있습니다.
          </Typography>
          <Typography gutterBottom align="center">
            크롬 브라우저로 접속하시거나
          </Typography>
          <Typography>
            아래 링크를 통해 브라우저를 설치 후 사용해주시기 바랍니다.
          </Typography>
        </View>
        <View alignItems="center">
          <Button
            fullWidth
            onClick={onClickLink}
            variant="contained"
            color="primary"
          >
            <Typography white>크롬 다운로드</Typography>
          </Button>
        </View>
      </DialogContent>
    </Dialog>
  );
}

export default IEDialog;
